const COMMENTS = [
  {
    id: 1,
    name: '追漫小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20boy%20avatar%20icon%2C%20chibi%20style%2C%20orange%20hair%2C%20happy%20expression%2C%20simple%20warm%20background%2C%20clean%20cartoon%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '3天前',
    rating: 5,
    content: '这个网站真的太棒了！追了快两年了，更新速度超级快，热门漫画基本同步更新。而且画质清晰，翻页流畅，用手机看体验也很好。已经推荐给身边所有追漫的朋友了！',
    tag: '忠实读者',
  },
  {
    id: 2,
    name: '樱花漫语',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20icon%2C%20chibi%20style%2C%20pink%20hair%2C%20smiling%20expression%2C%20simple%20soft%20background%2C%20clean%20cartoon%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '1周前',
    rating: 5,
    content: '作为恋爱漫画重度爱好者，这里的恋爱漫画太全了！从经典的《恋爱方程式》到最新连载的甜宠作品，应有尽有。而且完全免费，真的太良心了。每天睡前都要看几话才能安心入睡~',
    tag: '恋爱漫读者',
  },
  {
    id: 3,
    name: '热血漫魂',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20boy%20avatar%20icon%2C%20chibi%20style%2C%20dark%20hair%2C%20determined%20expression%2C%20simple%20dark%20background%2C%20clean%20cartoon%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '2周前',
    rating: 5,
    content: '热血漫的死忠粉在此！《暗影猎手》《剑道无双》《机甲战神》每一部都在追。特别喜欢网站的专题推荐功能，通过精选专题又发现了好几部宝藏漫画。免费漫画大全名副其实，五星好评！',
    tag: '热血漫读者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            读者热评
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            数百万漫迷的真实评价，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5"
            >
              <div className="flex items-start gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                />
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                      {comment.tag}
                    </span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: comment.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap ml-auto">{comment.time}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}